import React, { Component } from 'react'
import { Button, Row, Col } from 'react-bootstrap'

class BreadcrumbsSection extends Component {
    render() {
        const { breadcrumbs, type, addStudentButton, updateSectionButton, btn_type } = this.props;
 
        return (
            <>
                {
                    type !== "multiple" ? (
                        <div className="breadcrumb_section border-bottom border-theme pb-3 mb-4 d-flex align-items-center justify-content-between mt-2">
                            <h2 className="title h5 mb-0">{this.props.breadcrumbs.Title}</h2>
                            {this.props.type == "student" ? ("") : (<Button variant="success" className="text-uppercase px-4" onClick={() => this.props.onClick()}>{this.props.breadcrumbs.btnName}</Button>)}
                        </div>
                    ) : (
                        <Row className='mt-4'>
                            <Col xl={12} lg={12} md={12} sm={12}>
                                <div className="breadcrumb_section  my-2 d-flex align-items-center justify-content-between bred_sec mt-2">
                                    <h2 className="text-uppercase text-dark title h5 mb-0 tit_name" >{this.props.breadcrumbs.Title}</h2>
                                    <div className='d-flex justify-content-end but_three'>
                                        {type !== 'student' && (
                                            <>
                                                <Button
                                                    variant="success" className="text-uppercase px-4 mr-2"
                                                    onClick={addStudentButton}
                                                >
                                                    {breadcrumbs.btnName1}
                                                </Button>
                                                <Button
                                                    variant="secondary" className="text-uppercase px-4 mr-2"
                                                    onClick={updateSectionButton}
                                                >
                                                    {breadcrumbs.btnName2}
                                                </Button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    )
                }
            </>
        )
    }
}

export default BreadcrumbsSection
